export default __webpack_public_path__ + "static/media/catbears-all-set.12532ee1.png";